import React from "react";
import { Box } from "@mui/joy";
import ProjectDeadlines from "./ProjectDeadlines";

export default function RightSidebar() {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 3 }}>
            <ProjectDeadlines />
        </Box>
    );
}
